import { render, staticRenderFns } from "./appLoader.vue?vue&type=template&id=00cb2b4a"
import script from "./appLoader.vue?vue&type=script&lang=js"
export * from "./appLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports